/*
  Quick-add form interceptor.

  Progressive enhancement: catches submits on [data-quick-add-form], hands
  the FormData to window.MugCart.add(), shows a brief "ADDING…" label on the
  button.

  Critical guard: preventDefault() ONLY when window.MugCart exists. If the
  mug-cart.js script failed to load or hasn't initialized yet, the form
  submits traditionally to /cart/add and the user lands on /cart — they
  still get their mug. Never block the form submit without a working
  replacement.
*/

(() => {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add-form]');
    if (!form) return;

    if (!window.MugCart || typeof window.MugCart.add !== 'function') {
      // Let the browser submit the form to /cart/add the old-fashioned way.
      return;
    }

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const originalLabel = btn?.textContent;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'ADDING…';
    }

    try {
      await window.MugCart.add(new FormData(form));
    } catch (err) {
      console.error('Quick-add failed:', err);
      // Re-enable so the user can retry.
    } finally {
      if (btn) {
        btn.disabled = false;
        if (originalLabel) btn.textContent = originalLabel;
      }
    }
  });
})();
